<mat-card class="otp-card otp-card--white" appearance="raised">
  <mat-card-content class="card-content-container">
    <mat-icon svgIcon="otp-unidentified-browser" class="card-icon"></mat-icon>
    <p class="otp-p otp-p__body--highlight header" i18n>Задай въпрос</p>
    <p class="otp-p article" i18n>
      Задай въпрос или сподели твоите впечатления. Mнението ти е ценно за нас.
    </p>
    <button
      matButton="filled"
      class="otp-button"
      i18n
      data-testid="footer-open-feedback-button"
      (click)="openFeedbackPage()"
    >
      Задай въпрос
    </button>
  </mat-card-content>
</mat-card>
